import { Guide } from '@/entities/assets';

export const sortGuides = (a: Guide, b: Guide) => {
  // this function sorts guides with image sizes, rectangles should be first
  if (a.image.Height - a.image.Width > b.image.Height - b.image.Width) {
    return -1;
  }
  return 0;
};
